module.exports = __webpack_public_path__ + "assets/img/back-bb194aae.png";